import React from 'react';

import { isEmpty, map } from 'lodash';

import { Action, FILTER_OPTIONS } from '../constants';
import { useAccountListContext } from '../context';

const FilterTags: React.FC = () => {
  const { state, dispatch } = useAccountListContext();
  const { filters, search, totalCount } = state;

  const handleRemoveFilter = (key: string) => (): void => {
    dispatch({
      type: Action.REMOVE_FILTER,
      key,
    });
  };

  const getKeyLabel = (key: string): string => {
    return FILTER_OPTIONS.find((filter) => filter.value === key)?.label || '';
  };

  const isFiltering = search || !isEmpty(filters);

  return (
    <div className="flex items-center mt-2 ml-2">
      {isFiltering && <p className="text-gray-1.0 font-semibold">Filter Results ({totalCount})</p>}
      {!isEmpty(filters) && (
        <div className="ml-2">
          {map(filters, (values, key) => (
            <span
              key={key}
              className="inline-flex items-center px-2 py-1 rounded bg-white-0.0 border border-white-3.0 flex-wrap mr-2"
            >
              <p className="text-primary-1.0 font-semibold">
                {getKeyLabel(key)}: {values.type === 'boolean' && values.options[0].value}
                {values.type === 'select' && values.options.map((item) => item.label).join(', ')}
              </p>
              <button
                type="button"
                className="focus:outline-none inline-flex flex-shrink-0 ml-2"
                aria-label="Remove filter"
                onClick={handleRemoveFilter(key)}
              >
                <i className="icon-reject_icon font-semibold text-primary-1.0" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterTags;
